export const headers = [
  { field: "id", headerName: "ID", width: 70 , hidden: true},
  { field: "aof_nombre", headerName: "Descripción", width: 220 },
  {
    field: "aof_tipo",
    headerName: "Tipo De Oferta",
    width: 220,
    valueGetter: (params) => params.row.aof_tipo === 0 ? "Oferta por Fecha" : "Oferta por Fecha y Stock",
  },
  {
    field: "aof_tipoprecio",
    headerName: "Tipo De Precio",
    width: 150,
    valueGetter: (params) => params.row.aof_tipoprecio === 0 ? "Mayorista" : "Minorista",
  },
];
